import { Container, Tab, Tabs, useTheme } from '@mui/material';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';

import { PROFILE_SUBNAV_HEIGHT } from '@/config/constants';
import { LOAN_PATH, LOAN_TAB_ITEMS } from '@/config/loanNavPaths';

export const LoanNavTabs = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  if (!location.pathname.startsWith('/loan')) return null;

  const matched = LOAN_TAB_ITEMS.find((t) =>
    matchPath({ path: t.path, end: true }, location.pathname)
  );

  const tabValue = matched?.path ?? LOAN_PATH.hub;

  return (
    <Container
      maxWidth="lg"
      sx={{
        borderTop: `1px solid ${theme.palette.greyShades.border1}`,
        backgroundColor: theme.palette.mainColors.background1,
        minHeight: PROFILE_SUBNAV_HEIGHT,
      }}
    >
      <Tabs
        value={tabValue}
        onChange={(_, nextPath: string) => navigate(nextPath)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          minHeight: PROFILE_SUBNAV_HEIGHT,
          '& .MuiTab-root': {
            minHeight: PROFILE_SUBNAV_HEIGHT,
            color: theme.palette.greyShades.grey1,
            '&.Mui-selected': {
              color: theme.palette.mainColors.primary,
            },
          },
          '& .MuiTabs-indicator': {
            backgroundColor: theme.palette.mainColors.primary,
          },
        }}
      >
        {LOAN_TAB_ITEMS.map((item, index) => (
          <Tab
            key={item.path}
            id={item.tabId}
            label={item.label}
            value={item.path}
            aria-controls={`loan-section-${index}`}
          />
        ))}
      </Tabs>
    </Container>
  );
};
